import { Action } from '@ngrx/store';
import { GetNavigationInformationResponseInterface, IAllowedDomain} from './main.model';

export enum MainActionTypes {
  GetNavigationMenu = '[Main] Get Navigation Menu',
  GetNavigationMenuCompleted = '[Main] Get Navigation Menu Completed',
  SendContactSupport = '[Main] Send Contact Support',
  SendContactSupportCompleted = '[Main] Send Contact Support Completed',
  SwitchHomePage = '[Main] Switch Home Page',
  AllowedDomains = '[Main] Get Allowed Domains',
  AllowedDomainsCompleted = '[Main] Get Allowed Domains Completed',
  FetchError = '[Main] Fetch Error',
}

export class FetchError implements Action {
  readonly type = MainActionTypes.FetchError;

  constructor(public payload: any[]) {}
}


export class GetNavigationMenu implements Action {
  readonly type = MainActionTypes.GetNavigationMenu;
}

export class GetNavigationMenuCompleted implements Action {
  readonly type = MainActionTypes.GetNavigationMenuCompleted;

  constructor(public data: GetNavigationInformationResponseInterface, public success: boolean) {}
}

export class SendContactSupport implements Action {
  readonly type = MainActionTypes.SendContactSupport;

  constructor(
    public contactType: string,
    public textSubject: string,
    public textBody: string,
    public mail: boolean,
    public sms: boolean,
    public userId: string,
    public customMailGroupId: number | null = null,
    public siteId: number,
    public lineId: number,
    public fromUserId: number,
  ) {}
}

export class SendContactSupportCompleted implements Action {
  readonly type = MainActionTypes.SendContactSupportCompleted;

  constructor(public payload: string) {}
}

export class SwitchHomePage implements Action {
  readonly type = MainActionTypes.SwitchHomePage;

  constructor(public status: boolean) {}
}

export class AllowedDomains implements Action {
  readonly type = MainActionTypes.AllowedDomains;

  constructor() {}
}

export class AllowedDomainsCompleted implements Action {
  readonly type = MainActionTypes.AllowedDomainsCompleted;

  constructor(public data: IAllowedDomain[]) {}
}

export type MainActions =
  | FetchError
  | GetNavigationMenu
  | GetNavigationMenuCompleted
  | SendContactSupport
  | SendContactSupportCompleted
  | AllowedDomains
  | AllowedDomainsCompleted
  | SwitchHomePage;
